export const articles = [
  {
    id: '1',
    title: '2026年城市生活指南：凤楼区域居住品质全面升级',
    slug: '2026-city-living-guide-fenglou-upgrade',
    excerpt: '随着城市更新计划的推进，凤楼区域的基础设施和居住环境正在经历前所未有的提升。本文将为您详细解读新变化。',
    content: `<p>2026年，凤楼区域迎来了城市更新的重要一年。从交通基础设施到社区服务配套，一系列升级改造工程正在有序推进。</p>
<h2>交通出行更加便捷</h2>
<p>今年上半年，地铁新线路延伸至凤楼核心区域，大大缩短了居民通勤时间。新增的三个地铁站点覆盖了主要居住区和商业区，日均客流量预计将突破15万人次。与此同时，公交线路也进行了优化调整，新增了两条社区微循环线路，打通了出行的"最后一公里"。</p>
<h2>社区配套设施完善</h2>
<p>社区服务中心、医疗卫生站、文体活动中心等公共服务设施已完成升级改造。新开放的凤楼社区公园占地约2.5万平方米，设有健身步道、儿童游乐区和休闲广场，成为居民日常休闲的好去处。此外，两个标准化菜市场已完成智慧化改造，支持线上订购和线下配送。</p>
<h2>商业配套日趋成熟</h2>
<p>凤楼商业综合体将于年底开业，总建筑面积达12万平方米，汇集了购物、餐饮、娱乐等多种业态。目前已确认入驻的品牌超过150家，将为区域居民提供一站式的消费体验。</p>
<h2>居住品质持续提升</h2>
<p>多个老旧小区完成了综合整治，包括外墙保温、电梯加装、停车位扩容等项目。据统计，已完成改造的小区居民满意度达到92%以上。物业服务标准化建设也在持续推进，越来越多的社区引入了智能化管理系统。</p>
<p>展望下半年，凤楼区域还将有更多利好消息。城市绿道二期工程即将启动，规划全长约8公里，将串联起区域内的主要公园和景点。教育资源方面，两所九年一贯制学校正在建设中，预计2027年秋季投入使用。</p>`,
    category: '本地生活',
    categorySlug: 'local-life',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20residential%20community%20with%20green%20parks%20and%20new%20apartment%20buildings%2C%20clean%20streets%2C%20warm%20sunlight%2C%20architectural%20photography%2C%20bright%20and%20airy%20atmosphere%2C%20editorial%20style&width=1600&height=900&seq=article-1-2026&orientation=landscape',
    author: '凤楼资讯编辑',
    publishedAt: '2026-08-05',
    readTime: 8,
    tags: ['城市更新', '居住品质', '凤楼发展', '社区建设'],
    views: 12580,
    isFeatured: true,
  },
  {
    id: '2',
    title: '凤楼餐饮行业2026上半年发展报告：新业态引领消费潮流',
    slug: 'fenglou-food-industry-2026-half-year-report',
    excerpt: '2026年上半年，凤楼区域餐饮行业呈现多元化发展趋势，新兴餐饮业态不断涌现，消费者需求更加精细化。',
    content: `<p>2026年上半年，凤楼区域餐饮市场展现出强劲的发展势头。根据行业数据显示，上半年区域餐饮总收入同比增长18.5%，增速创近三年新高。</p>
<h2>新兴餐饮业态崛起</h2>
<p>社区食堂、共享厨房、预制菜体验店等新兴业态在凤楼区域快速发展。目前区域内已有超过30家社区食堂投入运营，以实惠的价格和便捷的服务受到居民欢迎。共享厨房模式则为小微餐饮创业者提供了低成本的创业平台，上半年新入驻的餐饮品牌中，超过40%选择共享厨房作为起点。</p>
<h2>消费者偏好变化</h2>
<p>健康饮食理念深入人心，轻食沙拉、低糖饮品等品类销量增长显著。有机食材和本地食材的关注度持续攀升，越来越多的餐厅开始标注食材来源。外卖平台数据显示，凤楼区域健康餐品订单同比增长35%。</p>
<h2>数字化赋能加速</h2>
<p>智能点餐系统、会员管理系统、后厨数字化管理等技术的应用越来越普及。超过80%的餐厅已接入至少一个外卖平台，线上营收占比持续提升。部分领先品牌已经开始尝试AI菜品推荐和智能库存管理。</p>
<h2>夜间经济持续升温</h2>
<p>凤楼区域的夜间餐饮消费场景不断丰富。夜市、深夜食堂、音乐餐吧等业态为消费者提供了更多选择。上半年夜间餐饮消费额占比达到全天总额的32%，较去年同期提升5个百分点。</p>`,
    category: '美食探店',
    categorySlug: 'food',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20restaurant%20interior%20with%20warm%20lighting%2C%20elegant%20dining%20atmosphere%2C%20wooden%20tables%2C%20stylish%20decor%2C%20food%20photography%20style%2C%20cozy%20ambiance%2C%20natural%20light&width=1600&height=900&seq=article-2-2026&orientation=landscape',
    author: '美食观察员',
    publishedAt: '2026-08-03',
    readTime: 6,
    tags: ['餐饮行业', '美食趋势', '夜间经济', '数字化转型'],
    views: 8920,
    isFeatured: true,
  },
  {
    id: '3',
    title: '凤楼科技创新园区入驻企业突破200家，产业集聚效应显著',
    slug: 'fenglou-tech-park-200-enterprises',
    excerpt: '凤楼科技创新园区自开园以来发展迅速，目前已吸引超过200家科技企业入驻，形成了以人工智能和数字经济为核心的产业生态。',
    content: `<p>凤楼科技创新园区近日迎来了第200家入驻企业，标志着园区发展进入新阶段。这家专注于智能机器人研发的科技公司选择在凤楼设立研发中心，看中的正是园区日益完善的产业生态和创新氛围。</p>
<h2>产业集聚效应凸显</h2>
<p>目前园区已形成人工智能、数字经济、生物医药三大主导产业集群。入驻企业中，高新技术企业占比超过65%，专精特新企业数量达到38家。园区企业总估值超过500亿元，其中估值超10亿元的企业有12家。</p>
<h2>创新生态持续优化</h2>
<p>园区配套建设了公共技术服务平台、知识产权服务中心和投融资对接平台，为企业提供全方位的创新支持。上半年园区企业新增专利申请量达到420件，其中发明专利占比超过60%。产学研合作不断深化，园区已与6所高校建立了合作关系。</p>
<h2>人才吸引力不断增强</h2>
<p>园区及周边完善的生活配套和政策支持，正在吸引越来越多的科技人才。园区配套的人才公寓已入住率超过90%，国际学校、商业综合体等生活设施一应俱全。据统计，园区从业人员中硕士及以上学历占比达到45%。</p>
<h2>展望未来</h2>
<p>园区二期工程正在规划中，预计新增产业空间约30万平方米。随着更多优质企业的入驻和创新资源的集聚，凤楼科技创新园区有望成为区域科技创新的重要引擎。</p>`,
    category: '科技数码',
    categorySlug: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20tech%20office%20park%20with%20glass%20buildings%2C%20green%20landscaping%2C%20innovative%20architecture%2C%20clean%20minimal%20design%2C%20bright%20daylight%2C%20professional%20corporate%20photography%2C%20warm%20neutral%20tones&width=1600&height=900&seq=article-3-2026&orientation=landscape',
    author: '科技频道记者',
    publishedAt: '2026-08-01',
    readTime: 7,
    tags: ['科技创新', '产业园区', '人工智能', '数字经济'],
    views: 6720,
    isFeatured: true,
  },
  {
    id: '4',
    title: '暑期出游旺季：凤楼周边五大避暑胜地推荐',
    slug: 'summer-travel-fenglou-nearby-destinations',
    excerpt: '炎炎夏日，为您精选凤楼周边五大清凉避暑好去处，从山林溪谷到湖滨度假，总有一款适合您的周末出游计划。',
    content: `<p>随着气温持续攀升，找一个清凉的地方避暑成为许多市民的首选。其实不必远行，凤楼周边就隐藏着不少避暑好去处。今天就为大家推荐五个各具特色的避暑胜地。</p>
<h2>一、翠云山国家森林公园</h2>
<p>距凤楼仅40分钟车程，海拔800-1200米，夏季平均气温比市区低8-10度。公园内古木参天，溪流潺潺，设有完善的徒步路线和露营区域。特色体验：森林瑜伽、星空露营、山泉戏水。</p>
<h2>二、碧波湖度假区</h2>
<p>以湖光山色闻名的碧波湖，是夏季水上运动的热门目的地。可以体验皮划艇、帆船、水上自行车等项目，湖畔有多家精品民宿可供住宿。推荐在湖边餐厅品尝新鲜的湖鲜美食。</p>
<h2>三、清凉谷生态农庄</h2>
<p>一个集采摘、垂钓、农家乐于一体的生态农庄，尤其适合亲子出游。夏季正是水蜜桃、葡萄成熟的季节，可以体验亲自采摘的乐趣。农庄还提供手工制作课程，孩子们可以学习制作果酱和果汁。</p>
<h2>四、温泉山谷度假村</h2>
<p>虽然是夏季，但温泉山谷的冷泉浴和山泉泳池同样吸引人。度假村依山而建，环境清幽，适合想要彻底放松的都市人。SPA中心和瑜伽课程也是不错的选择。</p>
<h2>五、古镇石板街</h2>
<p>拥有600多年历史的古镇，青石板路、明清建筑、小桥流水，处处透着清凉的韵味。古镇的特色小吃不容错过，手工豆腐花、桂花糕、冰镇酸梅汤都是消暑佳品。</p>`,
    category: '旅游出行',
    categorySlug: 'travel',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20mountain%20landscape%20with%20lush%20green%20forest%2C%20clear%20stream%2C%20summer%20sunlight%20filtering%20through%20trees%2C%20natural%20scenery%2C%20peaceful%20atmosphere%2C%20travel%20photography%2C%20vibrant%20greens&width=1600&height=900&seq=article-4-2026&orientation=landscape',
    author: '旅行达人小风',
    publishedAt: '2026-07-28',
    readTime: 6,
    tags: ['暑期出游', '避暑胜地', '周边游', '旅行攻略'],
    views: 15320,
    isFeatured: false,
  },
  {
    id: '5',
    title: '凤楼商业综合体招商进度过半，超百家品牌已确认入驻',
    slug: 'fenglou-commercial-complex-tenant-progress',
    excerpt: '备受关注的凤楼商业综合体项目进展顺利，招商工作已完成过半，涵盖零售、餐饮、娱乐等多个领域的品牌即将入驻。',
    content: `<p>凤楼商业综合体项目自启动招商以来，市场反响热烈。项目运营方近日透露，目前招商进度已超过55%，确认入驻的品牌超过100家，预计将于今年年底正式开业。</p>
<h2>主力品牌阵容揭晓</h2>
<p>已确认入驻的主力品牌包括国内知名百货连锁、国际快时尚品牌以及多家首进区域的新锐品牌。其中，一家面积超过3000平方米的精品超市将成为区域最大的生活超市。影院方面，一家拥有IMAX厅的现代化多厅影院将填补区域高端观影体验的空白。</p>
<h2>餐饮阵容强大</h2>
<p>餐饮区将汇集超过40家品牌，涵盖中餐、西餐、日料、东南亚料理等多种菜系。其中不乏首次进入凤楼市场的网红餐饮品牌。屋顶花园餐厅和美食广场等创新业态也将为消费者带来全新的用餐体验。</p>
<h2>亲子业态丰富</h2>
<p>考虑到周边家庭的消费需求，商业综合体内规划了超过2000平方米的亲子娱乐空间，包括室内游乐场、儿童职业体验馆和亲子餐厅等。此外还设有母婴室、儿童卫生间等贴心配套设施。</p>
<h2>智慧商业新体验</h2>
<p>商业综合体将全面引入智能化管理系统，包括智能停车、电子导购、会员积分互通等功能。消费者通过手机即可实现室内导航、排队取号、优惠领取等操作。</p>`,
    category: '商务资讯',
    categorySlug: 'business',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20shopping%20mall%20interior%20with%20bright%20atrium%2C%20glass%20ceiling%2C%20elegant%20stores%2C%20warm%20lighting%2C%20contemporary%20architecture%2C%20high-end%20retail%20environment%2C%20clean%20and%20spacious&width=1600&height=900&seq=article-5-2026&orientation=landscape',
    author: '商业观察员',
    publishedAt: '2026-07-25',
    readTime: 5,
    tags: ['商业综合体', '招商', '零售业', '凤楼商业'],
    views: 9450,
    isFeatured: false,
  },
  {
    id: '6',
    title: '凤楼全民健身月启动：社区运动设施使用指南',
    slug: 'fenglou-fitness-month-community-sports',
    excerpt: '全民健身月活动在凤楼各社区同步启动，本文将为您梳理区域内最值得打卡的运动场所和设施。',
    content: `<p>8月是凤楼区域的全民健身月，一系列丰富多彩的体育活动正在各社区展开。无论您是健身达人还是运动新手，都能找到适合自己的活动。</p>
<h2>社区运动设施大盘点</h2>
<p>目前凤楼区域内共有社区健身点32个，篮球场18个，羽毛球场24个，乒乓球台超过50张，基本实现了15分钟健身圈覆盖。所有设施均免费向居民开放，部分场馆支持线上预约。</p>
<h2>专业运动场馆推荐</h2>
<p>除了社区免费设施，区域内还有多家专业运动场馆。凤楼体育中心拥有标准游泳馆、室内篮球馆和健身房，收费合理，设施专业。新开的城市运动公园则主打户外运动，设有攀岩墙、滑板场和极限运动区。</p>
<h2>健身月精彩活动</h2>
<p>健身月期间将举办社区篮球赛、羽毛球友谊赛、趣味运动会等20余场活动。最受期待的千人健步走活动将于8月中旬在凤楼滨河公园举行。所有活动均可通过社区公众号免费报名参加。</p>
<h2>科学健身小贴士</h2>
<p>夏季运动需注意防暑降温，建议选择清晨或傍晚时段锻炼。运动前充分热身，运动后及时补充水分和电解质。初次运动者建议从低强度运动开始，循序渐进。</p>`,
    category: '本地生活',
    categorySlug: 'local-life',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20community%20sports%20park%20with%20outdoor%20fitness%20equipment%2C%20basketball%20courts%2C%20running%20tracks%2C%20green%20trees%2C%20people%20exercising%2C%20bright%20sunlight%2C%20healthy%20lifestyle%2C%20warm%20atmosphere&width=1600&height=900&seq=article-6-2026&orientation=landscape',
    author: '社区通讯员',
    publishedAt: '2026-07-22',
    readTime: 5,
    tags: ['全民健身', '社区运动', '健康生活', '凤楼体育'],
    views: 7820,
    isFeatured: false,
  },
  {
    id: '7',
    title: '5G+AI赋能：凤楼智慧城市建设迈入新阶段',
    slug: 'fenglou-smart-city-5g-ai',
    excerpt: '凤楼区域智慧城市建设取得阶段性成果，5G网络覆盖率达98%，AI技术在城市管理、交通、医疗等领域深度应用。',
    content: `<p>随着5G网络的全域覆盖和AI技术的深入应用，凤楼智慧城市建设正加速推进。从智能交通到远程医疗，科技正在悄然改变着居民的日常生活。</p>
<h2>5G网络全域覆盖</h2>
<p>截至目前，凤楼区域5G基站数量已超过1200个，实现了98%以上的区域覆盖。5G网络下载速率平均达到800Mbps以上，为各类智慧应用提供了坚实的网络基础。下半年还将新增约200个基站，进一步提升网络质量和覆盖密度。</p>
<h2>AI赋能城市管理</h2>
<p>城市管理领域已部署多项AI应用。智能视频分析系统可自动识别占道经营、乱停车等违规行为，处置效率提升约40%。智能垃圾分类系统通过图像识别技术，帮助居民正确分类投放垃圾。智慧路灯系统可根据人流量自动调节亮度，实现节能约30%。</p>
<h2>智慧交通缓解拥堵</h2>
<p>AI交通信号灯优化系统已在20个主要路口部署，通过实时分析车流量数据动态调整信号灯配时，高峰期通行效率提升约25%。智能停车系统覆盖了区域内80%的公共停车场，支持车位查询、预约和线上缴费。</p>
<h2>远程医疗服务普及</h2>
<p>凤楼社区卫生服务中心已接入市级远程医疗平台，居民可通过社区终端进行在线问诊、预约挂号和健康咨询。AI辅助诊断系统在影像诊断领域初步应用，提高了基层医疗机构的诊断能力。</p>`,
    category: '科技数码',
    categorySlug: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20smart%20city%20with%205G%20technology%2C%20digital%20infrastructure%2C%20modern%20urban%20landscape%2C%20IoT%20devices%2C%20clean%20streets%2C%20warm%20evening%20light%2C%20technology%20concept%2C%20sophisticated%20atmosphere&width=1600&height=900&seq=article-7-2026&orientation=landscape',
    author: '科技频道记者',
    publishedAt: '2026-07-20',
    readTime: 7,
    tags: ['智慧城市', '5G', '人工智能', '城市管理'],
    views: 5610,
    isFeatured: false,
  },
  {
    id: '8',
    title: '周末探店：凤楼老街隐藏的5家宝藏小店',
    slug: 'weekend-food-hunt-fenglou-old-street',
    excerpt: '在凤楼老街的巷弄深处，隐藏着许多不为人知但味道绝佳的小店。今天就带大家探寻那些只有本地人才知道的美味。',
    content: `<p>凤楼老街是区域最具烟火气的地方。在那些不起眼的巷弄里，藏着许多开了十几年甚至几十年的老店。今天，我们精选了5家最值得一试的宝藏小店。</p>
<h2>1. 老陈家面馆（经营35年）</h2>
<p>藏在凤楼老街第三条巷子里的老陈家面馆，是真正的地道老店。招牌红烧牛肉面汤底醇厚，牛肉软烂入味，面条劲道十足。35年来价格只涨了3次，至今一碗面只要18元。老板陈大爷说："做面就是做人，要对得起每一位食客。"</p>
<h2>2. 桂姐手工水饺</h2>
<p>每天清晨6点，桂姐就开始手工包制水饺。皮薄馅大是她的招牌特色，猪肉白菜和韭菜鸡蛋是点单最多的口味。水饺每个只要1元，配上自制的蒜蓉醋汁，鲜美无比。</p>
<h2>3. 老街豆腐坊</h2>
<p>这家豆腐坊已经有40年历史，每天凌晨制作的手工豆腐、豆花和豆浆，保留了最传统的味道。咸豆花配上榨菜、虾皮和辣椒油，是很多老街居民从小吃到大的味道。</p>
<h2>4. 阿福烧烤</h2>
<p>虽然名叫烧烤，但他家的招牌其实是烤鱼。选用一斤半左右的鲜活草鱼，用秘制酱料腌制后炭火慢烤，外焦里嫩，香气四溢。配上一碗白米饭，就是完美的晚餐。</p>
<h2>5. 小时光甜品店</h2>
<p>开在老街拐角处的小时光，主打传统广式甜品。双皮奶、杨枝甘露、芝麻糊都是手工制作，味道正宗。老板娘说这些配方都是从奶奶那里传下来的，每一碗都是小时候的味道。</p>`,
    category: '美食探店',
    categorySlug: 'food',
    coverImage: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20old%20street%20food%20alley%20with%20small%20local%20restaurants%2C%20steaming%20noodle%20shops%2C%20warm%20yellow%20lighting%2C%20nostalgic%20atmosphere%2C%20street%20food%20photography%2C%20authentic%20Chinese%20culture%2C%20cozy%20vibe&width=1600&height=900&seq=article-8-2026&orientation=landscape',
    author: '美食探索者',
    publishedAt: '2026-07-18',
    readTime: 5,
    tags: ['探店', '老街美食', '地道小吃', '宝藏店铺'],
    views: 11230,
    isFeatured: false,
  },
  {
    id: '9',
    title: '2026下半年凤楼楼市展望：刚需仍是主力，改善需求上升',
    slug: 'fenglou-real-estate-outlook-2026-h2',
    excerpt: '专业机构发布凤楼区域楼市半年报，分析下半年市场走势，刚需购房仍是市场主力，改善型需求占比持续提升。',
    content: `<p>近日，多家房地产研究机构发布了凤楼区域2026年上半年楼市报告。数据显示，区域楼市整体保持平稳运行态势，成交量较去年同期小幅增长。</p>
<h2>上半年市场回顾</h2>
<p>上半年凤楼区域新房成交面积约28万平方米，同比增长5.2%。二手房成交量约3500套，同比增长8.7%。成交均价保持稳定，新房均价维持在每平方米3.2万元左右，二手房均价约2.5万元。</p>
<h2>刚需仍是市场主力</h2>
<p>从购房人群结构来看，首次置业者占比约55%，仍是市场的绝对主力。90后和95后成为购房主力年龄段，他们更加注重交通便利性和社区配套。小户型产品去化速度较快，80-100平方米的两房和三房最受欢迎。</p>
<h2>改善需求持续上升</h2>
<p>随着二胎、三胎家庭的增加，改善型需求占比从去年同期的25%上升至32%。120-140平方米的大三房和四房产品需求增长明显。购房者更加关注社区品质、教育配套和物业服务。</p>
<h2>下半年展望</h2>
<p>下半年预计将有5个新盘入市，新增供应约2000套。随着地铁新线的开通和商业配套的完善，部分板块的关注度有望提升。专家建议购房者根据自身需求理性选择，重点关注地段和品质。</p>`,
    category: '商务资讯',
    categorySlug: 'business',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20residential%20apartment%20buildings%20in%20Chinese%20city%2C%20clean%20facade%2C%20green%20trees%2C%20blue%20sky%2C%20real%20estate%20photography%2C%20bright%20sunlight%2C%20urban%20living%2C%20warm%20neutral%20colors&width=1600&height=900&seq=article-9-2026&orientation=landscape',
    author: '房产分析师',
    publishedAt: '2026-07-15',
    readTime: 6,
    tags: ['楼市分析', '刚需购房', '改善需求', '房产市场'],
    views: 10340,
    isFeatured: false,
  },
  {
    id: '10',
    title: '凤楼文化艺术节开幕：一个月的文化盛宴等你来',
    slug: 'fenglou-culture-art-festival-2026',
    excerpt: '一年一度的凤楼文化艺术节正式拉开帷幕，汇集了展览、演出、讲座等百余场活动，将持续整整一个月。',
    content: `<p>8月1日，2026凤楼文化艺术节在凤楼文化中心盛大开幕。本届艺术节以"城市·人文·生活"为主题，将在为期一个月的时间里举办超过100场文化活动。</p>
<h2>重磅展览不容错过</h2>
<p>本次艺术节的重头戏包括"当代水墨艺术展"和"城市记忆摄影展"。水墨展汇集了30余位当代水墨艺术家的代表作，摄影展则通过百余幅老照片和当代摄影作品，呈现凤楼区域的城市变迁。两个展览均免费向公众开放。</p>
<h2>精彩演出轮番上演</h2>
<p>艺术节期间，凤楼大剧院将上演多场精彩演出，包括经典话剧《雷雨》、民族舞剧《丝路花雨》以及多场交响乐音乐会。户外广场还将举行社区文艺汇演和街头艺人表演，让艺术走进市民生活。</p>
<h2>文化讲座和工坊</h2>
<p>为了让市民更深入地参与其中，艺术节还安排了丰富的文化讲座和互动工坊。书法、国画、剪纸、陶艺等传统手工艺体验课程每周举办，由非遗传承人亲自教学。文学讲座则邀请了多位知名作家分享创作心得。</p>
<h2>亲子互动专区</h2>
<p>特别设置的亲子互动专区深受家庭欢迎。儿童戏剧、绘本阅读、手工制作等活动寓教于乐，让孩子们在游戏中感受文化的魅力。</p>`,
    category: '休闲娱乐',
    categorySlug: 'entertainment',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultural%20art%20festival%20with%20traditional%20and%20modern%20art%20displays%2C%20ink%20painting%20exhibition%2C%20warm%20gallery%20lighting%2C%20elegant%20atmosphere%2C%20cultural%20event%2C%20artistic%20photography%2C%20rich%20textures&width=1600&height=900&seq=article-10-2026&orientation=landscape',
    author: '文化频道编辑',
    publishedAt: '2026-08-02',
    readTime: 5,
    tags: ['文化艺术节', '展览', '演出', '文化活动'],
    views: 7680,
    isFeatured: true,
  },
  {
    id: '11',
    title: '凤楼新能源汽车充电桩布局再升级，年底前新增500个',
    slug: 'fenglou-ev-charging-station-expansion',
    excerpt: '为满足日益增长的新能源汽车充电需求，凤楼区域将在年底前新增500个公共充电桩，覆盖主要商圈和居民区。',
    content: `<p>随着新能源汽车保有量的快速增长，充电基础设施的建设成为影响用户体验的关键。凤楼区域今年启动了充电桩倍增计划，预计年底前新增公共充电桩500个。</p>
<h2>现有充电设施概况</h2>
<p>目前凤楼区域内共有公共充电桩约380个，主要集中在商业综合体、写字楼和部分住宅小区。但随着新能源汽车保有量突破8000辆，现有充电设施已难以满足需求，特别是高峰时段排队现象明显。</p>
<h2>新增布局方案</h2>
<p>根据规划，新增的500个充电桩将分布在以下区域：商业区（150个）、居民小区（200个）、公共停车场（100个）、高速公路服务区（50个）。快充桩占比将达到60%，大幅提升充电效率。</p>
<h2>智能化升级</h2>
<p>新增充电桩将全部接入统一管理平台，支持手机APP查询、预约和支付。智能调度系统可根据实时需求分配充电资源，减少等待时间。部分充电站还将配备储能系统，实现削峰填谷。</p>
<h2>政策支持</h2>
<p>此次充电桩建设获得了市级的专项资金支持，同时鼓励社会资本参与建设和运营。对于在自有车位安装充电桩的居民，可享受最高2000元的安装补贴。</p>`,
    category: '科技数码',
    categorySlug: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20electric%20vehicle%20charging%20station%20with%20new%20energy%20cars%2C%20clean%20technology%2C%20bright%20daytime%2C%20organized%20parking%20lot%2C%20green%20energy%20concept%2C%20sustainable%20infrastructure%2C%20professional%20photography&width=1600&height=900&seq=article-11-2026&orientation=landscape',
    author: '出行频道记者',
    publishedAt: '2026-07-12',
    readTime: 5,
    tags: ['新能源', '充电桩', '绿色出行', '基础设施建设'],
    views: 5890,
    isFeatured: false,
  },
  {
    id: '12',
    title: '秋季周边游提前规划：凤楼出发三日自驾路线推荐',
    slug: 'autumn-road-trip-fenglou-three-days',
    excerpt: '立秋已过，正是规划秋季自驾游的好时节。为您推荐一条从凤楼出发的三日自驾路线，沿途风景美不胜收。',
    content: `<p>立秋之后，天气渐凉，正是自驾出游的黄金季节。今天就为大家推荐一条从凤楼出发的三日自驾路线，串联了山水古镇、自然风光和特色美食。</p>
<h2>Day 1：凤楼 → 古堰画乡 → 云和梯田（约180公里）</h2>
<p>早上从凤楼出发，沿高速行驶约2小时抵达古堰画乡。这里是中国摄影之乡，古老的堰坝和徽派建筑构成绝美画面。午餐推荐在画乡品尝当地的溪鱼和笋干烧肉。下午前往云和梯田，秋季的梯田层林尽染，是拍摄日落的绝佳地点。晚上入住梯田景区内的精品民宿。</p>
<h2>Day 2：云和梯田 → 仙都景区 → 缙云县城（约120公里）</h2>
<p>清晨在民宿阳台欣赏梯田日出后，驱车前往仙都景区。这里是多部仙侠影视剧的取景地，鼎湖峰、倪翁洞等景点各有特色。中午品尝缙云烧饼和敲肉羹。下午游览后前往缙云县城，晚上逛县城老街，品尝当地小吃。</p>
<h2>Day 3：缙云 → 河阳古民居 → 凤楼（约200公里）</h2>
<p>上午游览河阳古民居，这是一个保存完好的千年古村落，青砖黛瓦、马头墙，处处是景。午餐在古村品尝农家菜。下午沿高速返回凤楼，途中可在服务区稍作休息，傍晚抵达。</p>
<h2>出行贴士</h2>
<p>建议提前预订住宿，特别是周末和节假日。秋季早晚温差较大，需备外套。山路驾驶注意安全，保持车距，谨慎超车。</p>`,
    category: '旅游出行',
    categorySlug: 'travel',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20autumn%20Chinese%20countryside%20road%20trip%20scenery%2C%20golden%20rice%20terraces%2C%20misty%20mountains%2C%20winding%20road%2C%20warm%20autumn%20colors%2C%20scenic%20landscape%2C%20travel%20photography%2C%20peaceful%20atmosphere&width=1600&height=900&seq=article-12-2026&orientation=landscape',
    author: '自驾游达人',
    publishedAt: '2026-07-10',
    readTime: 6,
    tags: ['自驾游', '秋季出游', '旅行路线', '周边游'],
    views: 9120,
    isFeatured: false,
  },
];

export const featuredArticles = articles.filter((a) => a.isFeatured);
export const latestArticles = articles.sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime());